import { createSetQueryAction } from './queryActions';
import { loadTileData } from './tileDataThunkActions';
export function queryChanged(query) {
    return function(dispatch, getState) {
        return Promise.resolve().then(()=>{
            dispatch(createSetQueryAction({
                query
            }));
            return dispatch(loadTileData());
        }).catch((err)=>Promise.reject(err));
    };
}
